import { render, staticRenderFns } from "./LoadParcelsFromBus.vue?vue&type=template&id=0dca7d26&"
import script from "./LoadParcelsFromBus.vue?vue&type=script&lang=js&"
export * from "./LoadParcelsFromBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports